<main class="landing">
  <header class="landing-header header-publico">
    <div class="logos-header" aria-label="Logos institucionales">
      <img src="assets/img/logo-gobierno.png" alt="Gobierno de Chile" class="logo-gobierno" />
      <img src="assets/img/logo-anid.svg" alt="ANID" class="logo-anid" />
    </div>

    <div class="header-actions">
      <a routerLink="/seleccion-roles" class="btn-login">
        <span class="claveunica-icon" aria-hidden="true"></span>
        Iniciar sesión
      </a>
    </div>
  </header>

  <section class="hero hero-banner">
    <div class="hero-content">
      <h1>Sistema de Postulación Bilingüe ANID</h1>
      <p>{{ mensajeBienvenida }}</p>
      <div class="hero-buttons">
        <a routerLink="/seleccion-roles" class="btn-primary">
          <span class="claveunica-icon" aria-hidden="true"></span>
          Iniciar sesión
        </a>
        <a href="#calendario" class="btn-calendar" aria-label="Ir a la sección calendario" (click)="irACalendario($event)">
          Ir a calendario <span aria-hidden="true">↓</span>
        </a>
      </div>
    </div>
  </section>

  <section class="info-calendar">
    <h2>¿Qué es el Sistema de Postulación Bilingüe ANID?</h2>
    <p>
      Es la plataforma oficial de la ANID que permite a personas, instituciones y equipos de investigación postular a
      convocatorias y programas de financiamiento. Facilita la gestión de postulaciones, el seguimiento de su estado y la
      transparencia de cada etapa del proceso.
    </p>
  </section>

  <section class="info-calendar">
    <h2>¿Qué es el Calendario ANID?</h2>
    <p>
      Es una vista de fechas, hitos y convocatorias relevantes de ANID. Permite consultar aperturas, cierres y actividades
      asociadas a concursos para planificar mejor cada etapa del proceso de postulación.
    </p>
  </section>

  <section id="calendario" class="calendar-section" tabindex="-1" aria-label="Sección calendario ANID">
    <h3>Calendario ANID</h3>
    <div class="calendar-card">
      <ng-container *ngIf="usarCalendarioOficial; else calendarioMock">
        <iframe [src]="calendarioAnidUrlOficial" title="Calendario oficial ANID" width="100%" height="780" loading="lazy"></iframe>
      </ng-container>
      <ng-template #calendarioMock>
        <app-calendario-anual></app-calendario-anual>
      </ng-template>
    </div>
  </section>
</main>
